import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { GET_SAVED_VIEWS_QUERY } from './useGetSavedViews';

type DeleteSavedViewVariables = {
  savedViewId: number;
  viewName: string;
};

export const useDeleteSavedView = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: ({ savedViewId }: DeleteSavedViewVariables) =>
      api.request(endpoints.savedViews.delete(savedViewId)),
    onSuccess: (_data, { viewName }) => {
      queryClient.invalidateQueries({ queryKey: [GET_SAVED_VIEWS_QUERY] });
      notify.default({
        title: intl.formatMessage(
          { id: 'containers.savedViews.drawer.notifications.deleted' },
          { viewName }
        ),
      });
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'containers.savedViews.drawer.notifications.error',
        }),
      });
    },
  });
};
